// istanbul ignore file
import type { Routes } from '@angular/router';

import { authGuard } from '@cf/features/auth/shell';
import { setOrganizationResolver } from '@cf/features/organizations/admin';
import { AppContainerPageComponent } from './app-container.page';
import { RedirectComponent } from './redirect.component';
import { redirectGuard, redirectMatcher } from './redirect.guard';

export const routes: Routes = [
  {
    path: '',
    component: AppContainerPageComponent,
    children: [
      {
        path: 'org/:orgId',
        resolve: {
          organizations: setOrganizationResolver,
        },
        children: [
          {
            path: 'dashboard',
            loadChildren: () => import('../dashboard/routes').then((m) => m.dashboardRoutes),
            canActivate: [authGuard],
          },
          {
            path: 'admin',
            loadChildren: () =>
              import('@cf/features/organizations/admin-shell').then((m) => m.adminRoutes),
            canActivate: [authGuard],
          },
          {
            path: 'groups',
            loadChildren: () => import('../groups/routes').then((m) => m.groupsRoutes),
            canActivate: [authGuard],
          },
          {
            path: 'events',
            loadChildren: () => import('../events/routes').then((m) => m.routes),
            canActivate: [authGuard],
          },
          {
            path: 'meeting',
            loadChildren: () => import('../meeting/routes').then((m) => m.meetingRoutes),
            canActivate: [authGuard],
            data: {
              routeScope: 'dashboard',
            },
          },
          {
            path: '**',
            redirectTo: '/error/404',
          },
        ],
      },
      {
        path: 'integrations',
        loadChildren: () => import('@cf/features/integrations').then((m) => m.integrationsRoutes),
        canActivate: [authGuard],
      },
      {
        path: 'settings',
        loadChildren: () => import('../settings/routes').then((m) => m.settingsRoutes),
        canActivate: [authGuard],
      },
      {
        matcher: redirectMatcher,
        component: RedirectComponent,
        canActivate: [redirectGuard],
      },
    ],
  },
];
